{
  "familyId": "REK-CONTEXT-KEER-DEEL",
  "questions": [
    {
      "id": "REK-CONTEXT-KEER-DEEL-001",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een bakker bakt elke dag 144 broodjes. Ze verpakt ze in zakken van 12. Hoeveel zakken heeft ze nodig?",
      "options": ["12 zakken", "14 zakken", "11 zakken", "13 zakken"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "Je verdeelt 144 broodjes in groepjes van 12. Dat is delen: 144 ÷ 12 = 12 zakken. Tip: als je iets 'gelijk verdeelt' of 'in groepjes' stopt, is dat altijd delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_verdelen",
      "variantIndex": 1,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.78,
      "feedback": {
        "explanationText": "144 broodjes in zakken van 12 = 144 ÷ 12 = 12 zakken. Het signaalwoord 'verpakt in zakken van' wijst op delen. Je verdeelt het totaal in gelijke groepjes.",
        "solutionSteps": [
          "Herken de bewerking: verdelen in groepjes = delen",
          "144 ÷ 12 = 12",
          "De bakker heeft 12 zakken nodig"
        ],
        "distractorExplanations": {
          "0": "Goed! 144 ÷ 12 = 12 zakken.",
          "1": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 14. Maar 14 × 12 = 168 ≠ 144. Controleer: 12 × 12 = 144. ✓",
          "2": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 11. Maar 11 × 12 = 132 ≠ 144. Controleer: 12 × 12 = 144. ✓",
          "3": "Je dacht waarschijnlijk 144 ÷ 12 ≈ 13. Maar 13 × 12 = 156 ≠ 144. Controleer: 12 × 12 = 144. ✓"
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 144÷12≈14", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 144÷12≈11", "optionIndex": 2 },
          { "id": "rek.calculation-error", "label": "Deelfout: 144÷12≈13", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-002",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een tuinman plant 15 rijen met elk 24 bloembollen. Hoeveel bloembollen plant hij in totaal?",
      "options": ["350", "340", "360", "375"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Rijen × per rij = totaal",
            "content": "15 rijen met elk 24 bollen = 15 × 24. Handig: 15 × 24 = 15 × 20 + 15 × 4 = 300 + 60 = 360. Signaalwoord: 'rijen met elk' wijst op vermenigvuldigen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_rijen",
      "variantIndex": 2,
      "citoDifficulty": 0.46,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "15 rijen × 24 bollen = 360 bollen. Signaalwoord: 'rijen met elk' wijst op vermenigvuldigen. Handig: 15 × 24 = 15 × 20 + 15 × 4 = 300 + 60 = 360.",
        "solutionSteps": [
          "Herken: rijen × per rij = vermenigvuldigen",
          "15 × 24 = 15 × 20 + 15 × 4",
          "300 + 60 = 360 bloembollen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 15 x 24 = 350. Maar 15 x 20 = 300 en 15 x 4 = 60, samen 360. Niet 350.",
          "1": "Je dacht waarschijnlijk 15 x 24 = 340. Controleer: 15 x 20 = 300, 15 x 4 = 60, samen 360.",
          "2": "Goed! 15 x 24 = 360 bloembollen in totaal.",
          "3": "Je dacht waarschijnlijk 15 x 25 = 375. Maar er zijn 24 bollen per rij, niet 25. 15 x 24 = 360."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Vermenigvuldigfout: 15×24≈350", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Vermenigvuldigfout: 15×24≈340", "optionIndex": 1 },
          { "id": "rek.rounding-wrong-direction", "label": "Rondt 24 af naar 25: 15×25=375", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-003",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een school bestelt 756 pennen. De pennen worden geleverd in dozen van 18. Hoeveel dozen moet de school bestellen?",
      "options": ["40 dozen", "42 dozen", "44 dozen", "38 dozen"],
      "correctAnswer": 1,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Hoeveel dozen? = delen",
            "content": "'Hoeveel dozen van 18 passen in 756?' = 756 ÷ 18. Handig: 756 ÷ 18 = 756 ÷ 2 ÷ 9 = 378 ÷ 9 = 42. Of: 18 × 40 = 720, rest 36. 36 ÷ 18 = 2. Totaal: 42 dozen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_dozen",
      "variantIndex": 3,
      "citoDifficulty": 0.52,
      "citoDiscrimination": 0.82,
      "feedback": {
        "explanationText": "756 ÷ 18 = 42 dozen. Signaalwoord: 'dozen van 18' wijst op delen. Handig: 756 ÷ 2 = 378, dan 378 ÷ 9 = 42. De school moet 42 dozen bestellen.",
        "solutionSteps": [
          "Herken: totaal ÷ per doos = aantal dozen",
          "756 ÷ 18 = 756 ÷ 2 ÷ 9",
          "378 ÷ 9 = 42 dozen"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 756 / 18 = 40. Maar 40 x 18 = 720, niet 756. Er zijn nog 36 pennen over: 36 / 18 = 2 dozen extra. Totaal: 42.",
          "1": "Goed! 756 / 18 = 42 dozen.",
          "2": "Je dacht waarschijnlijk 756 / 18 = 44. Maar 44 x 18 = 792, niet 756. Controleer: 42 x 18 = 756.",
          "3": "Je dacht waarschijnlijk 756 / 20 = 37,8 dus 38. Maar de deler is 18, niet 20. 756 / 18 = 42."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.division-remainder-ignored", "label": "Vergeet rest bij deling: 756÷18≈40", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 756÷18≈44", "optionIndex": 2 },
          { "id": "rek.context-wrong-data", "label": "Deelt door 20 i.p.v. 18", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-004",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een fietsenmaker vervangt 4 banden per fiets. Hij heeft 348 banden op voorraad. Hoeveel fietsen kan hij volledig van nieuwe banden voorzien?",
      "options": ["86 fietsen", "88 fietsen", "84 fietsen", "87 fietsen"],
      "correctAnswer": 3,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Per fiets = delen",
            "content": "Elke fiets heeft 4 banden nodig. Hoeveel fietsen van 348 banden? 348 ÷ 4 = 87. Let op: een fiets heeft 2 wielen, maar elk wiel heeft 2 banden (binnen- en buitenband). Dus 4 banden per fiets.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_per_stuk",
      "variantIndex": 4,
      "citoDifficulty": 0.48,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "348 banden ÷ 4 banden per fiets = 87 fietsen. Signaalwoord: 'per fiets' wijst op delen. 348 ÷ 4 = 87. De fietsenmaker kan 87 fietsen volledig van nieuwe banden voorzien.",
        "solutionSteps": [
          "Herken: totaal ÷ per fiets = aantal fietsen",
          "348 ÷ 4 = 87",
          "87 fietsen volledig voorzien"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 348 / 4 = 86. Maar 86 x 4 = 344, niet 348. Controleer: 87 x 4 = 348.",
          "1": "Je dacht waarschijnlijk 348 / 4 = 88. Maar 88 x 4 = 352, niet 348. Controleer: 87 x 4 = 348.",
          "2": "Je deelde waarschijnlijk 348 / 4 = 84. Maar 84 x 4 = 336, niet 348. Controleer: 87 x 4 = 348.",
          "3": "Goed! 348 / 4 = 87 fietsen."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.calculation-error", "label": "Deelfout: 348÷4≈86", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 348÷4≈88", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 348÷4≈84", "optionIndex": 2 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-005",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "multiple_choice",
      "question": "Een drukkerij drukt 28 pagina's per minuut. Een boek heeft 336 pagina's. Hoeveel minuten duurt het om één boek te drukken?",
      "options": ["14 minuten", "10 minuten", "12 minuten", "11 minuten"],
      "correctAnswer": 2,
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Totaal ÷ per minuut = tijd",
            "content": "336 pagina's ÷ 28 pagina's per minuut = 12 minuten. Handig: 336 ÷ 28 = 336 ÷ 4 ÷ 7 = 84 ÷ 7 = 12. Signaalwoord: 'per minuut' wijst op delen.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_snelheid",
      "variantIndex": 5,
      "citoDifficulty": 0.54,
      "citoDiscrimination": 0.80,
      "feedback": {
        "explanationText": "336 ÷ 28 = 12 minuten. Signaalwoord: 'per minuut' wijst op delen. Handig: splits 28 in factoren: 28 = 4 × 7. Eerst 336 ÷ 4 = 84, dan 84 ÷ 7 = 12.",
        "solutionSteps": [
          "Herken: totaal ÷ per minuut = aantal minuten",
          "336 ÷ 28 = 336 ÷ 4 ÷ 7",
          "84 ÷ 7 = 12 minuten"
        ],
        "distractorExplanations": {
          "0": "Je dacht waarschijnlijk 336 / 24 = 14. Maar de snelheid is 28 pagina's per minuut, niet 24. 336 / 28 = 12.",
          "1": "Je dacht waarschijnlijk 336 / 28 = 10. Maar 10 x 28 = 280, niet 336. Controleer: 12 x 28 = 336.",
          "2": "Goed! 336 / 28 = 12 minuten.",
          "3": "Je dacht waarschijnlijk 336 / 28 = 11. Maar 11 x 28 = 308, niet 336. Controleer: 12 x 28 = 336."
        }
      },
      "pedagogy": {
        "dok": 2,
        "misconceptionTags": [
          { "id": "rek.context-wrong-data", "label": "Deelt door 24 i.p.v. 28", "optionIndex": 0 },
          { "id": "rek.calculation-error", "label": "Deelfout: 336÷28≈10", "optionIndex": 1 },
          { "id": "rek.calculation-error", "label": "Deelfout: 336÷28≈11", "optionIndex": 3 }
        ]
      }
    },
    {
      "id": "REK-CONTEXT-KEER-DEEL-006",
      "familyId": "REK-CONTEXT-KEER-DEEL",
      "module": "Basisrekenen",
      "tier": 9,
      "levelCode": "M7",
      "group": 7,
      "skill": "context",
      "subSkill": "context_vermenigvuldigen_delen",
      "questionType": "step_solver",
      "question": "Een boer heeft 480 appels. Hij verpakt ze in kratten van 24. Hoeveel kratten heeft hij nodig? Los stap voor stap op.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "steps": [
          {
            "prompt": "Welke bewerking gebruik je? Verdelen in groepjes = ...",
            "correctAnswer": "delen",
            "acceptedAnswers": ["delen", "÷", "deelsom"],
            "hint": "Je verdeelt 480 appels in groepjes van 24. Dat is ..."
          },
          {
            "prompt": "Bereken: 480 ÷ 24 = ? (Tip: 480 ÷ 4 = 120, dan 120 ÷ 6 = ?)",
            "correctAnswer": "20",
            "acceptedAnswers": ["20"],
            "hint": "480 ÷ 24. Splits 24 in 4 × 6. Eerst 480 ÷ 4 = 120. Dan 120 ÷ 6 = ?"
          },
          {
            "prompt": "Controleer: 20 × 24 = ?",
            "correctAnswer": "480",
            "acceptedAnswers": ["480"],
            "hint": "20 × 24 = 20 × 20 + 20 × 4 = ?"
          }
        ]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Verdelen = delen",
            "content": "480 appels in kratten van 24 = 480 ÷ 24. Handig: splits 24 in factoren: 24 = 4 × 6. Eerst 480 ÷ 4 = 120, dan 120 ÷ 6 = 20.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "context_keer_deel_step_solver",
      "variantIndex": 6,
      "citoDifficulty": 0.45,
      "citoDiscrimination": 0.76,
      "feedback": {
        "explanationText": "480 appels ÷ 24 per krat = 20 kratten. Handig rekenen: 480 ÷ 4 = 120, dan 120 ÷ 6 = 20. Controleer: 20 × 24 = 480 ✓.",
        "solutionSteps": [
          "Herken: verdelen in groepjes = delen",
          "480 ÷ 24 = 480 ÷ 4 ÷ 6 = 120 ÷ 6 = 20",
          "Controleer: 20 × 24 = 480 ✓"
        ]
      },
      "pedagogy": {
        "dok": 2
      }
    }
  ]
}